import type { apiSchemas } from '@trinity/management-app-client';

type FieldDefinition = apiSchemas.FieldDefinition;

export interface FormValidation {
  isValid: boolean;
  fieldErrors: Record<string, string>;
  hasErrors: boolean;
}

const CONSTANTS = {
  VALIDATION: {
    REQUIRED: 'This field is required',
  },
} as const;

type FormField = FieldDefinition;

export const validateForm = (formData: Record<string, unknown>, fields: FormField[]): FormValidation => {
  const fieldErrors: Record<string, string> = {};
  let hasErrors = false;

  fields.forEach(field => {
    const value = formData[field.name];

    if (field.required) {
      const isEmpty =
        value === undefined ||
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        fieldErrors[field.name] = CONSTANTS.VALIDATION.REQUIRED;
        hasErrors = true;
      }
    }
  });

  return {
    isValid: !hasErrors,
    fieldErrors,
    hasErrors,
  };
};

